export default __webpack_public_path__ + "static/media/Group 84.6c1829cf.png";